// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"9ce78ce5","453":"ac9b7e2a","796":"8d3290e9"}[chunkId] + ".chunk.js";
};